export const LOCAL_STORAGE_CONFIGURATOR_KEY = 'last_send_offer_hash';

// Different types of configurator modes
export const CONFIGURATOR_MODE = {
	CREATE: 'create', // First create or no current subscription
	EDIT: 'edit' // Edit current subscription
};

// Different types of configurator restoration
export const CONFIGURATOR_RESTORE = {
	NONE: 'none', // Do not restore (default)
	PAYMENT: 'payment', // Restore after failed payment
	MYID: 'myID' // Restore after myId confirmation
};

export const PACKET_PRICE_DIFFERENCE = {
	CURRENT: 'current',
	DOWNGRADE: 'downgrade',
	UPGRADE: 'upgrade'
};

export const EXTERNAL_LOCAL_STORAGE = 'external';
export const RESTORE_LOCAL_STORAGE = 'restore';
export const SELECTED_PACKET_LOCAL_STORAGE = 'selected_packet';
export const SHOW_PAYMENT_FAILED_MODAL = 'payment_failed_modal';
export const EMAIL_SENDER_LOCK = 'sending_offer_email';
export const EMAIL_SENDER_OFF = 'email_sender_off';

export const URL_LANDING_PAGE = '/tv/strona-glowna';
export const URL_CONFIGURATOR_SUCCESS = '/konfigurator/sukces';
export const URL_CONFIGURATOR = '/konfigurator';
export const URL_USER_PROFILE_DEVICES = '/uzytkownik/urzadzenia';
export const URL_USER_PROFILE_YOUR_PACKETS = '/uzytkownik/twoje-pakiety';
export const URL_LOGIN = '/logowanie';

export const DETAILS_REFETCH_INTERVAL = 5000;

export const CONFIGURATOR_RETURN_URL = 'c_r_u';
export const CONFIGURATOR_EMAIL = 'c_o_e';
export const CONFIGURATOR_SESSION_PRICE = 'c_s_p';
